import { type PopperProps, useTheme } from '@mui/material'
import { useMemo, useState } from 'react'
import type { LocationEditorState } from '../types.js'

export function usePopperProps(state: LocationEditorState, $root: HTMLElement | null) {
  const [popperRef, setPopperRef] = useState<HTMLDivElement | null>(() => null)
  const {
    zIndex: { tooltip: zIndex },
  } = useTheme()

  const { open } = state

  const popperProps = useMemo<PopperProps>(
    () => ({
      ref: setPopperRef,
      placement: 'bottom-start',
      open,
      anchorEl: $root,
      style: {
        zIndex,
      },
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 2],
          },
        },
      ],
    }),
    [$root, open, zIndex],
  )

  return {
    popperProps,
    popperRef,
  }
}
